import { useRef } from 'react';
import gsap from 'gsap';

const MagneticButton = ({ children, className = '', onClick, testId, as = 'button', href, target }) => {
  const ref = useRef(null);

  const onMouseMove = (e) => {
    const el = ref.current;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    gsap.to(el, { x: x * 0.25, y: y * 0.25, duration: 0.8, ease: 'power3.out' });
  };

  const onMouseLeave = () => {
    gsap.to(ref.current, { x: 0, y: 0, duration: 1, ease: 'elastic.out(1, 0.6)' });
  };

  const handleClick = (e) => {
    const el = ref.current;
    const rect = el.getBoundingClientRect();
    const ripple = document.createElement('span');
    ripple.className = 'ripple';
    const size = Math.max(rect.width, rect.height);
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${e.clientX - rect.left - size / 2}px`;
    ripple.style.top = `${e.clientY - rect.top - size / 2}px`;
    el.appendChild(ripple);
    setTimeout(() => ripple.remove(), 1100);
    if (onClick) onClick(e);
  };

  const Tag = as;
  return (
    <Tag
      ref={ref}
      href={href}
      target={target}
      rel={target ? 'noopener noreferrer' : undefined}
      data-testid={testId}
      className={`cta-btn inline-block ${className}`}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
      onClick={handleClick}
    >
      {children}
    </Tag>
  );
};

export default MagneticButton;
